
import React from 'react';
import { NikoFacilityOrderNewFlowInventoryCountEditModalTemplate} from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowInventoryCountEditModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowInventoryCountEditModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowInventoryCountEditModalStore')
@observer
class NikoFacilityOrderNewFlowInventoryCountEditModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowInventoryCountEditModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowInventoryCountEditModal;
